import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import axios from "axios";
import { useAuth } from "../../../context/auth-context";
import { formatDate, formatToZMW, handlePrint, rootUrl } from "../../../helpers";
import DataTable from "react-data-table-component";
import { FaEye, FaMoneyBill, FaPlus, FaPrint, FaShoppingCart, FaTimes } from "react-icons/fa";
import SlidingDiv from "../../../components/SlidingDiv";
import SupplierStatement from "./SupplierStatement";
import { useOutletContext } from 'react-router-dom';
import AddBillModal from "../bills/addBill";
import { toast } from "react-toastify";
import { MdPayments } from "react-icons/md";
import { customStyles } from "../../../styles";
import PaymentVoucher from "../../../components/PaymentVoucher";

const SupplierManagement = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [title, setTitle] = useState('');
  const [output, setOutput] = useState('');
  const [formType, setFormType] = useState(1); // 1: Invoice, 2: Payment
   const [transactions, setTransactions] = useState([]);
      const [filteredCashbooks, setFilteredCashbooks] = useState([]);
        const [filters, setFilters] = useState({
          startDate: '',
          endDate: '',
          bank: '',
          customer: '',
          search: '',
        });
  const [formData, setFormData] = useState({
    name: "",
    contactPerson: "",
    phoneNumber: "",
    email: "",
    address: "",
    type: "",
  });

  const {allData, setAllData} = useOutletContext();
  const auth = useAuth();
 const componentRef = useRef(null);
  const [isSlidingDivOpen, setIsSlidingDivOpen] = useState(false);
    const [showSlidingDiv, setShowSlidingDiv] = useState(false);
  const openSlidingDiv = () => {
    setShowSlidingDiv(true);
  };
  const closeSlidingDiv = () => {
    setShowSlidingDiv(false);
  };
  const toggleSlidingDiv = () => setIsSlidingDivOpen(!isSlidingDivOpen);


    useEffect(() => {
      axios.get(rootUrl(`/getPayments/${auth.user.id}`)) 
      .then((response) => setTransactions(response.data.data))
      .catch((error) => console.error("Error fetching suppliers:", error));
  
    }, []); 


    const display = (obj) => {
      openSlidingDiv();
      setTitle("Payment Voucher");
      setOutput(<PaymentVoucher data={obj} ref={componentRef} />);
    };
  // Handle form changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle modal open/close
  const toggleModal = () => setIsModalOpen((prev) => !prev);

  function isAnyValueEmpty(obj) {
    return Object.values(obj).some(value => 
        value === null || value === undefined || value === ''
    );
}



  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    
    
    formData['uid'] = auth.user.id
    try{
       if(isAnyValueEmpty(formData)){
            toast.error("Please ensure to fill in all fields")
            return
          }
          // formData['type'] = 0;
      const response = await axios.post(rootUrl("/addSupplier"), formData)
      if(response.data.status === 200){
        toast.success("Submitted successfully")
        toggleModal();
        setFormData(
          {
            name: "",
            contactPerson: "",
            phoneNumber: "",
            email: "",
            address: "",
            
          }
        )

        axios.get(rootUrl(`/getSuppliers/${auth.user.id}`)) 
      .then((response) => setAllData((prevData) => ({
        ...prevData, 
        suppliers: response.data.data,
      })))
      .catch((error) => console.error("Error fetching suppliers:", error));

      
      }else{
        toast.info(response.data.msg)
      }

    }catch(e){
      toast.error(e?.message)
    }

  };

  

  function viewSupp(id, type, name){

    

    openSlidingDiv()

    if(type === 1){
      setTitle('Supplier Statement')
      setOutput(<SupplierStatement id={id} name={name} />)
    }

    if(type === 2){
      setTitle('Add Payment')
      setOutput(<AddBillModal data={allData} onSubmit={onSubmit} type={2} />)
    }
  }


  
  const onSubmit = async (payload)=>{
    payload['uid'] = auth.user.id

    try{
        const response = await axios.post(rootUrl('/paySupplier'), payload)
        if(response.data.status === 200){
            toast.success("Submitted successfully")
            closeSlidingDiv()
            axios.get(rootUrl(`/getPayments/${auth.user.id}`)) 
      .then((response) => setTransactions(response.data.data))
      .catch((error) => console.error("Error fetching suppliers:", error));
  
        }else{
            toast.error("Something went wrong")
        }
    }catch(e){
        toast.error(e?.message)
    }
}


  const columns = [
     {
       name: 'Sn',
       selector: (row, index) => index + 1,
       sortable: true,
       width: '50px',
     },
     {
       name: 'Date',
       selector: (row) => formatDate(row.date.substring(0, 10)),
       sortable: true,
     },
     {
       name: 'Chart of Account',
       selector: (row) =>
         allData?.budget?.find((a) => a.id == row.coa_id)?.coa || '',
       sortable: true,
     },
     {
       name: 'Bank',
       selector: (row) =>
         allData?.bank?.find((a) => a.id === row.bank)?.name || '',
       sortable: true,
     },
     {
       name: 'Description',
       selector: (row) => row.description || '',
       sortable: true,
     },
     {
       name: 'Voucher #',
       selector: (row) => row.voucher || '',
       sortable: true,
     },{
       name: 'Cheque #',
       selector: (row) => row.cheque || '',
       sortable: true,
     },
     {
       name: 'Payee',
       selector: (row) => allData?.suppliers?.find((a) => a.id == row.paye)?.name || ''
         
       ,
       sortable: true,
     },
     {
       name: 'Project',
       selector: (row) => allData?.projects?.find((a) => a.id == row.proj_id)?.name || ''
       ,
       sortable: true,
     },
     {
       name: 'Debit',
       selector: (row) => (row.type === 'income' ? formatToZMW(row.amount) : 0),
       sortable: true,
     },
     {
       name: 'Credit',
       selector: (row) => (row.type === 'expense' ? formatToZMW(row.amount) : 0),
       sortable: true,
     },
     {
       name: 'Balance',
       selector: (row) => formatToZMW(row.balance || 0),
       sortable: true,
     },
     {
       name: 'Actions',
       cell: (row) => (
         <>
         <button
           className="bg-blue-950 hover:bg-blue-950 text-white px-3 py-1 m-1 rounded"
           onClick={() => display(row)}
         >
           <FaEye/>
         </button>
       </>
       ),
       ignoreRowClick: true,
       allowOverflow: true,
       button: true,
     },
   ];
  
   useEffect(() => {
     let filtered = transactions;
 
     if (filters.startDate) {
       filtered = filtered.filter((row) => {
         const rowDate = new Date(row.date);
         const startDate = new Date(filters.startDate);
       
         // Set the time part to midnight (00:00:00) for both dates
         rowDate.setHours(0, 0, 0, 0);
         startDate.setHours(0, 0, 0, 0);
       
         return rowDate >= startDate;
       });
       
       
     }
     if (filters.endDate) {
       filtered = filtered.filter((row) => {
         const rowDate = new Date(row.date);
         const endDate = new Date(filters.endDate);
       
         // Set the time part to midnight (00:00:00) for both dates
         rowDate.setHours(0, 0, 0, 0);
         endDate.setHours(0, 0, 0, 0);
       
         return rowDate <= endDate;
       });
       
       
     }
     if (filters.bank) {
       filtered = filtered.filter((row) => row.bank == filters.bank);
     }
     if (filters.customer) {
      filtered = filtered.filter((row) => row.paye == filters.customer);
    }
     if (filters.search) {
       filtered = filtered.filter(
         (row) =>
           row.description?.toLowerCase().includes(filters.search.toLowerCase()) ||
         row.voucher?.toLowerCase().includes(filters.search.toLowerCase()) ||
         row.cheque?.toLowerCase().includes(filters.search.toLowerCase()) 
       );
     }
     setFilteredCashbooks(filtered);
   }, [filters, transactions]);
   
   const finalBalance = filteredCashbooks.reduce((total, row) => {
     const amount = parseFloat(row.amount) || 0; 
     return row.type === 'income' ? total + amount : total - amount;
   }, 0);
   const calculateBalance = () => {
     let balance = 0;
     return filteredCashbooks.map((row) => {
       balance += row.type === 'income' ? parseFloat(row.amount) : - parseFloat(row.amount);
       return { ...row, balance };
     });
   };

   const customerOptions = [...new Set(transactions.map(res => res.paye))].map((cust) => {
    const supplier = allData?.suppliers.find(a => a.id == cust);
    return {
      value: cust,
      label: supplier?.name || cust,
    };
  });

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-950 to-blue-800 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="bg-white/20 rounded-xl p-3">
              <MdPayments className="text-2xl" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold">Payments</h1>
              <p className="text-blue-100 text-sm mt-1">
                Manage supplier and employee payments linked to your cashbook.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => viewSupp(1, 2, "")}
              className="inline-flex items-center bg-white/20 hover:bg-white/30 text-white h-9 px-3 rounded-lg text-xs md:text-sm font-medium transition-colors border border-white/30"
            >
              <FaPlus className="mr-1" /> Add Payment
            </button>
            <button
              onClick={toggleModal}
              className="inline-flex items-center bg-white/20 hover:bg-white/30 text-white h-9 px-3 rounded-lg text-xs md:text-sm font-medium transition-colors border border-white/30"
            >
              <FaPlus className="mr-1" />
              Add Payee
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full flex flex-col bg-white min-h-[400px] rounded-2xl p-4 md:p-6 shadow-sm border border-gray-100">

        {/* Supplier Table */}
        <div id="supTable">
          {/* Filters */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
          <input
            type="date"
            className="border border-gray-300 px-3 py-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={filters.startDate}
            onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
          />
          <input
            type="date"
            className="border border-gray-300 px-3 py-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={filters.endDate}
            onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
          />
          <select
            className="border border-gray-300 px-3 py-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={filters.bank}
            onChange={(e) => setFilters({ ...filters, bank: e.target.value })}
          >
            <option value="">All CashBooks</option>
            {allData?.bank?.map((bank) => (
              <option key={bank.id} value={bank.id}>
                {bank.name}
              </option>
            ))}
          </select>

          <Select
            options={customerOptions}
            placeholder="Payee"
            isClearable
            value={customerOptions.find(option => option.value === filters.customer)}
            onChange={(selectedOption) =>
              setFilters({ ...filters, customer: selectedOption ? selectedOption.value : "" })
            }
            className="text-sm"
          />
          <input
            type="text"
            placeholder="Search by description, voucher or cheque..."
            className="border border-gray-300 px-3 py-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value })}
          />
          <div className="flex items-center text-xs md:text-sm text-gray-600">
            <span className="font-medium mr-1">Showing:</span>
            {filteredCashbooks.length} record{filteredCashbooks.length === 1 ? "" : "s"}
          </div>
        </div>

          <p className="text-xs text-gray-500 mb-2">
            A list of all payments made to suppliers and employees.
          </p>

          <div className="rounded-xl border border-gray-100 bg-white overflow-hidden">
          <div className="overflow-x-auto">
            <DataTable
              title=""
              columns={columns}
              data={calculateBalance()}
              pagination
              highlightOnHover
              striped
              responsive
              customStyles={customStyles}
            />
          </div>
        </div>

          <div className="text-right font-semibold mt-3 text-sm md:text-base text-gray-800">
            Balance:{" "}
            <span className="font-bold text-blue-950">
              {formatToZMW(finalBalance)}
            </span>
          </div>
        </div>

        {/* Sliding voucher/statement panel */}
        {showSlidingDiv && (
        <div className="fixed inset-0 z-40 flex justify-end">
          <div
            className="flex-1 bg-black/40"
            onClick={closeSlidingDiv}
          />
          <div
            id="slidingDiv"
            className="bg-white h-full w-full sm:w-4/5 lg:w-2/3 xl:w-1/2 shadow-2xl relative flex flex-col"
          >
            <div className="flex items-center justify-between bg-gradient-to-r from-blue-950 to-blue-800 px-6 py-4 text-white p-3 border-b border-gray-200">
              <h3 className="font-semibold text-sm md:text-lg text-white">
                {title}
              </h3>
              <button
                onClick={closeSlidingDiv}
                className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-red-50 text-red-600 hover:bg-red-100"
              >
                <FaTimes size={14} />
              </button>
            </div>
            <div className="flex gap-3 p-3 border-b border-gray-100">
              <button
                onClick={() => handlePrint(componentRef)}
                className="inline-flex items-center bg-blue-950 text-white px-3 py-2 rounded-lg text-xs md:text-sm font-medium hover:bg-blue-900"
              >
                <FaPrint className="mr-1" />
                Print
              </button>
            </div>
            <div className="flex-1 overflow-auto p-3 md:p-4" id="form">
              {output}
            </div>
          </div>
        </div>
      )}

        {/* Add/Edit Payee Modal */}
        {isModalOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-4 md:p-5 w-full max-w-xl shadow-xl">
            {/* Modal Header */}
            <div className="flex justify-between items-center mb-3 border-b pb-3">
              <h2 className="text-lg md:text-xl font-semibold text-gray-800">
                {selectedSupplier ? "Edit Supplier" : "Add New Payee"}
              </h2>
              <button
                onClick={toggleModal}
                className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-gray-100 text-gray-600 hover:bg-gray-200"
              >
                <FaTimes size={14} />
              </button>
            </div>
            {/* Modal Body */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <select 
                className="border border-gray-300 rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={formData.type}
                onChange={handleInputChange}
                name="type"
              >
                <option value="">Select Type</option>
                <option value="1">Supplier</option>
                <option value="2">Employee</option>
              </select>
              <input
                name="name"
                placeholder={parseInt(formData.type) === 2 ? 'Employee Name' : 'Supplier Name'}
                value={formData.name}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                name="contactPerson"
                placeholder={parseInt(formData.type) === 2 ? 'Employee Man No' : 'Contact Person'}
                value={formData.contactPerson}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                name="phoneNumber"
                placeholder="Phone Number"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                name="address"
                placeholder="Address"
                value={formData.address}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {/* Other fields based on form type */}
              {formType === 2 && (
                <>
                  <Select
                    name="budget"
                    placeholder="Select Budget"
                    options={[]} // Populate options dynamically
                    onChange={(option) =>
                      setFormData((prev) => ({ ...prev, budget: option.value }))
                    }
                    className="text-sm"
                  />
                  <textarea
                    name="description"
                    placeholder="Description"
                    value={formData.description}
                    onChange={handleInputChange}
                    className="border border-gray-300 rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 md:col-span-2"
                  />
                </>
              )}
            </div>
            {/* Modal Footer */}
            <div className="flex justify-end mt-4 gap-2">
              <button
                onClick={toggleModal}
                className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-200"
              >
                Close
              </button>
              <button
                onClick={handleSubmit}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
};

export default SupplierManagement;
